import IAddress1UnitNoZipCode from '../common/IAddress1UnitNoZipCode';

export default interface ISalesHistorySelections {
    address1UnitNoZipCode: IAddress1UnitNoZipCode;
    chronologyNumbers: string[];
    excludeNonArmsLength: boolean;
    includeInAddenda: boolean;
    includeAnalysis: boolean;
}

export function newSalesHistorySelections(address1UnitNoZipCode: IAddress1UnitNoZipCode): ISalesHistorySelections {
    const selections: ISalesHistorySelections = {
        address1UnitNoZipCode: address1UnitNoZipCode,
        chronologyNumbers: [],
        excludeNonArmsLength: false,
        includeInAddenda: false,
        includeAnalysis: false
    };
    return selections;
}
